import React from "react";
import Header from "../../../Header";
import Footer from "../../../Footer";
import GEMHero from "./GEMHero";
import GEMServices from "./GEMServices";
import GEMBottomline from "./GEMBottomline";
import GEMFAQ from "./GEMFAQ";
import GEMInvestFit from "./GEMInvestFit";

const GEM = () => {


  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-grow">
        <GEMHero />
        <GEMServices />
        <GEMBottomline />
        <GEMInvestFit />
        <GEMFAQ />
      </main>
      <Footer />
    </div>
  );
};

export default GEM;